import { Link } from 'react-router-dom'
import './sidebar.scss'
import clsx from 'clsx'
import { ReactComponent as MusicIcon } from 'assets/icons/music.svg'
import { ReactComponent as PortfolioIcon } from 'assets/icons/portfolio.svg'
import { ReactComponent as GearIcon } from 'assets/icons/gear.svg'
import { ReactComponent as LogoutIcon } from 'assets/icons/logout.svg'
import Logo from 'assets/images/logo.png'

const Sidebar = ({ route }) => {
  return (
    <div className="w-[60px] pt-4 pb-2 px-2 h-full flex flex-col bg-purple-dark dark:bg-purple-black">
      <div className="flex items-center justify-center h-[50px]">
        <img src={Logo} alt="Sharefolio logo" />
      </div>
      <div className="mt-4 links flex-fill">
        <SidebarLink
          id="library"
          path="/library"
          name="Library"
          route={route}
          icon={MusicIcon}
        />
        <SidebarLink
          id="portfolios"
          path="/portfolios"
          name="Portfolios"
          route={route}
          icon={PortfolioIcon}
        />
      </div>
      <div>
        <SidebarLink
          id="account"
          path="/account"
          name="Account Settings"
          route={route}
          icon={GearIcon}
        />
        <SidebarLink
          id="logout"
          path="/logout"
          name="Logout"
          route={route}
          icon={LogoutIcon}
          iconColor="#e1e1e1"
        />
      </div>
    </div>
  )
}

const SidebarLink = ({
  path,
  id,
  name,
  icon,
  route,
  iconColor = '#ffffff',
}) => {
  const Icon = icon
  return (
    <Link
      to={path}
      key={path}
      className={clsx(
        'flex items-center justify-center',
        'mb-2 w-[44px] h-[44px]',
        'transition',
        'font-bold no-underline',
        'rounded-full',
        'hover:bg-purple-light',
        { 'bg-purple': id === route },
      )}
      data-tooltip={name}
      data-tooltip-offset="right"
    >
      <Icon height="24" width="24" fill={iconColor} stroke={iconColor} />
    </Link>
  )
}

export default Sidebar
